import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import Institution from 'src/app/interfaces/Institution';
import { UserService } from 'src/app/services/user.service';
import { InstitutionService } from 'src/app/services/institution.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-institutions',
  templateUrl: './institutions.component.html',
  styleUrls: ['./institutions.component.scss'],
})
export class InstitutionsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  user;
  locked = false;
  search = {
    term: '',
    isFocused: false,
  };
  institutions: Array<Institution> = [];
  filteredInstitutions: Array<any> = [];
  params = null;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private institutionService: InstitutionService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('institution_view');
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.user = u;
          this.locked = false;
          this.getInstitutions();
        } else {
          this.locked = true;
        }
      })
    );
  }

  getInstitutions() {
    this.subscriptions.add(
      this.institutionService.getInstitutions().subscribe(
        (instArr) => {
          this.institutions = instArr.filter((i) => i.institutionName !== null);
          this.filteredInstitutions = this.institutions;
          instArr.forEach((i) => {
            if (i.institutionName === null) {
              this.institutionService
                .deleteInstitution(i.id)
                .then(() => console.warn('deleted an empty institution'));
            }
          });
        },
        (e) => console.error(e)
      )
    )
  }
  filterChange(f) {
    this.filteredInstitutions = f.filteredList;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
